<template>
  <div class="master_admin_pathway manager_dashboard" ref="elementToDetectOutsideClick">
    <UserMenu></UserMenu>
    <div class="wrapper">
			<masteradmin-sidebar-menu />
      <div class="content-wrapper"  style="background-color: #FFF;">
        <div class="container-wrapper center" >

          <div>
            <div style="width: 70%; float: left; text-align: left; ">
              <h3 class="d-inline heading text-uppercase">Pathway Builder</h3>
            </div>
						<div style="width: 30%; float: left; text-align: right; ">
							&nbsp;
						</div>
            <div style="clear: both;"></div>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>

					<div class="row">
						<div class="col-6 p-0">

							<div class="col-12 pt-1">
								<div class="col-6 p-0 float-left">
									<nav id="sidebar1" 
										class="show_back_button"
									>
										<ul class="list-unstyled" @click="backToPathwayListsPage()">
											<li class="back_button_heading" style="cursor: pointer;" >
												
													<img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" style="margin-top: -3px !important;" />
													{{ pathwayName }}
												
											</li>
										</ul>
									</nav>
								</div>
								<div class="col-6 p-0 mt-1 float-right text-right" v-if="pathway_step_obj.steps.length > 0">
									<button class="btn btn-red btn-md input-height-15 font-13 step-buttons show_button_right_margin" style="text-transform: capitalize;" @click="editPathway()"
										>Edit Pathway</button>
								</div>
								<div style="clear: both;"></div>
							</div>

						</div>
					</div>


					<div class="row">
						<div class="col-6 p-0" v-if="stepLoading == false">


							<div class="row">
								<div class="col pt-2">
									<div class=" mb-3" v-for="(step, index) in pathway_step_obj.steps" v-if="step.stepTitle" >
										<div class="pathways_step rounded shadow mb-0 " >
											<div class="row">
												<div class="col-10 font-weight-bold text-left">
													&nbsp;
												</div>
												<div class="col-2 p-0 text-center" >
													<div class="px-0 pt-2 step-index" style="color: #778182;">Step {{ parseInt(index + 1) }}</div>
												</div>
												<div class="col-12 text-right pr-4">
												</div>
											</div>
											<div class="row mt-2" >
												<div class="col-9 font-weight-bold text-left" style="color: #778182;">
													<div class="px-4 pt-0">
														{{ step.stepTitle }} 
													</div>

												</div>
												<div class="col-3 text-center">
													&nbsp;
												</div>
											</div>
										</div>


										<!-- Pathway Objective -->
										<div v-for="(objective, oindex) in step.objective" >
										<div class="pathways_ojective_step_ul pathways_ojective_step rounded mb-0 ">
											<div class="row">
												<div class="col-10">
													<div class="pl-3 py-2">{{ objective.objectiveName }}</div>
												</div>
												<div class="col-2 text-center">
													&nbsp;
												</div>
											</div>
										</div>
										</div>
										<!-- End Pathway Objective -->


									</div>
								</div>

							</div>

						</div>

						

						<div class="col-6 font-13 pt-3 pr-0" style="position: fixed; right: 0; left: 50%;" v-if="addObjectiveModalVisible == true">
						</div>

					</div>
				</div>
			</div>
		</div>









	</div>



</template>
<script>

import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import { store } from '../../store/store';
import UserMenu from '@/components/shared/user_menu.vue';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import { Validator } from "vee-validate";
import router from '../../router/index.js';
import CreatePathwayStepModal from '../manager/create-pathway-modal.vue';
import EditPathwayStepModal from '../manager/create-pathway-modal.vue';
import DeleteModal from '../shared/delete_modal_alert.vue';
import PathwayCatalogBuilder from '../manager/pathway_builder.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

const stepTitleValue = ["First", "Second", "Third", "Fourth", "Fifth", "Sixth", "Seventh", "Eighth", "Ninth", "Tenth"];

export default {
        data() {
          return {
						pathwayId: '',
						pathway_step_obj: {
							pathway: [],
							steps: [],
							removed_objective: [],
							removed_step: [],
							flag: 'Insert',
						},
						pathwayName: '',
						addStepModalVisible: false,
						addObjectiveModalVisible: false,
						stepTitle: '',
						stepDescription: '',
						stepIndex: '',
						objectiveIndex: '',
						objectiveType: '',
						objectiveId: '',
						objectiveLoading: false,
						objectiveOptions: [],
						assessmentOptions: [],
						courseOptions: [],
						tasklistOptions: [],
						certificateOptions: [],
            isDeleteModalVisible: false,
						deleteList: '',
						deleteMessage: '',
						isopenPathwayCatalogBuilderVisible: false,
						loading: false,
						pathway_catalog_flag: 0,
						alertFlag: 0,
						stepLoading: false,
						isMasterAdmin: 0,
	        }
        },
        components: {
					UserMenu,
					MasteradminSidebarMenu,
        },
        beforeRouteLeave(to, from, next) {
          if (this.alertFlag == 1 && !confirm('Changes that you made to the pathway is not saved. Please save before leaving.')) 
					{
            next(false);
						this.alertFlag = 0;
					}
          else {
						next()
					}
        },
				mounted() {

				},
        methods: {
					editPathway() {
						this.$store.dispatch('pathway_steps', '');
            router.push("/masteradmin-pathway-catalog-step-builder/" + this.pathwayId);
					},
					getStepTitlValue(index) {
						return stepTitleValue[index];
					},
					doValidateStepTitle() {
						var flag = 0;
						for(var i=0; i < this.pathway_step_obj.steps.length; i++) {
							if(this.pathway_step_obj.steps[i].stepTitle == '') {
								flag = 1;
								alert("Please add step title for step - " + parseInt(i+1));
							}
						}
						return flag;
					},
					backToPathwayListsPage() {
						router.push("/masteradmin-pathway-catalog");
					},

					getPathwayStepDetails: function() {
						axios.get('/get-pathway-step-details', {
							params: {
								pathwayId: this.pathwayId,
							}
						})
						.then((resp) => {
								this.stepLoading = false;
								this.pathway_step_obj.pathway = resp.data.pathway;
								this.pathwayName = this.pathway_step_obj.pathway.name;
								this.pathway_step_obj.steps = resp.data.pathwayStep;
								this.flag = resp.data.flag;
								if(this.pathway_step_obj.steps.length > 0) {
									this.pathway_step_obj.flag = 'Update';
								}
								this.$store.dispatch('pathway_steps', this.pathway_step_obj);
						})
						.catch(error => {
							if(error.response.data.message == 'Access denied.') {
								router.push("/forbidden");
							}
						});

					},
				},

				created() {
					this.stepLoading = true;
					this.pathwayId = this.$route.params.pathway_id;
					this.getPathwayStepDetails();
					this.$store.dispatch('catalog_pathway_steps_flag', '');
				},
}

</script>

<style>
	.back_icon { width: 11px !important; }
	.back_button_heading {
		font-size: 16px;
		color: #646F71;
		font-weight: bold;
	}
	.pathwayBtn, .pathwayBtn:hover, .pathwayBtn:focus {
		padding: 7px 7px; border-radius: 15px !important;
		width: 130px;
	}
	.master_admin_pathway .pathways_step {
		height: 80px;
		width: 80%;
		margin-left: 40px;
		border-top-left-radius: 15px !important;
		border-top-right-radius: 15px !important;
		box-shadow: 0px 0px 5px rgba(0,0,0,.15) !important;
	}
	.manager_pathway .pathways_ojective_step_ul { 
		width: 79.77%;
		margin-left: 41px;
		border: 0;
	}
	.master_admin_pathway .pathways_ojective_step {
		min-height: 65px;
		margin-right: 0;
		border: 0;
		background-color: #E2F3F9;
		padding-top: 10px;
		color: #778182;
		font-size: 13px;
		padding-left: 8px;
		border-top: 0px solid #B2B2B2;
		box-shadow: 0 0px 1px rgba(0,0,0,.15) !important;
		border-radius: 0;
		font-weight: 600;

	}
	.master_admin_pathway .add_objective {
		height: 80px;
		width: 80%;
		margin-left: 40px;
		border-top: 0;
		box-shadow: 0px 0px 5px rgba(0,0,0,.15) !important;
	}
	.step-index {
		color: #778182;
		font-size: 12px;
	}
	.master_admin_pathway .subtask-wrapper {
		margin-top: 15px;
		margin-left: 40px;
		margin-right: 30px;
	}
	.master_admin_pathway .subtask-wrapper .panel-title a, .manager_pathway .subtask-wrapper .panel-title a:hover{
		color: #646F71 !important;
	}
	.angle_class_font {
		font-size: 25px !important;
		margin-top: 0px !important;
		color: #646F71 !important;
	}
	.line-height-15 {
		line-height: 15px;
	}
	.master_admin_pathway .show_button_right_margin {
		margin-right: 70px !important;
	}
	@media (max-width: 1670px) and (min-width: 1605px) {
		.master_admin_pathway .show_button_right_margin {
			margin-right: 80px !important;
		}
	}
	@media (min-width: 1800px) {
		.master_admin_pathway .show_button_right_margin {
			margin-right: 100px !important;
		}
	}
	@media (max-width: 1400px) {
		.master_admin_pathway .show_button_right_margin {
			margin-right: 50px !important;
		}
	}
</style>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/master_admin_pathway_catalog_step_show_pathway.vue